import { render, staticRenderFns } from "./MycollectCard.vue?vue&type=template&id=4bcc3120&scoped=true"
import script from "./MycollectCard.vue?vue&type=script&lang=js"
export * from "./MycollectCard.vue?vue&type=script&lang=js"
import style0 from "./MycollectCard.vue?vue&type=style&index=0&id=4bcc3120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc3120",
  null
  
)

export default component.exports